import { ShareOutlineIcon } from './ShareOutlineIcon';

/**
 * author: Nick
 * id B8DDA534-033E-42FF-9F81-62EC636DD3C6
 * name share-outline
 * version: 2.3.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/share-outline.svg
 * tags
 * - Arrow 
 */
export const ForwardOutlineIcon = ShareOutlineIcon;
export default ForwardOutlineIcon